import * as _ from "lodash"
import {
    IHierarchyStructure,
    IHierarchyStructureSalesArea
} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {
    WB_CustomerHierarchySalesAreaRow
} from "../PA.Core/PAdbSchemaRows";
import {esWB_Customer_Hierarchy_SalesArea} from "../PA.Core/PAdbSchema";

export class CustomerSalesArea
    implements IHierarchyStructureSalesArea {
    private _hierStructure: IHierarchyStructure

    private _wbSalesAreaId: number;

    private _bDelete: boolean

    // Create on Save
    private hierSARow: WB_CustomerHierarchySalesAreaRow

    constructor(structure: IHierarchyStructure, options?: { saRow?: WB_CustomerHierarchySalesAreaRow }) {
        this._hierStructure = structure
        this._bDelete = false
        this.hierSARow = options?.saRow

        if (!_.isEmpty(this.hierSARow)) {
            this._wbSalesAreaId = this.hierSARow.cif.WB_SALESAREA_ID
        }
    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get wbSalesAreaId(): number {
        return this._wbSalesAreaId
    }

    setWbSalesAreaId(wbSalesAreaId: number): void {
        this._wbSalesAreaId = wbSalesAreaId || 0
    }


    get isActive(): boolean {
        return !this._bDelete
    }

    get isActiveNew(): boolean {
        return (_.isEmpty(this.hierSARow) && !this._bDelete)
    }

    get isModified(): boolean {
        if (_.isEmpty(this.hierSARow))
            return false

        if (this._bDelete && !_.isEmpty(this.hierSARow))
            return true

        let wbSalesAreaId = this._wbSalesAreaId

        if (this.hierSARow.cif.WB_SALESAREA_ID != wbSalesAreaId)
            return true

        return false
    }

    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        const self = this
        if (!self.isModified && !self.isActiveNew)
            return

        // create record if needed
        if (_.isEmpty(self.hierSARow)) {
            if (self._bDelete)
                return

            self.hierSARow = <WB_CustomerHierarchySalesAreaRow> await self._hierStructure.dbContext.createRecordWithKey(esWB_Customer_Hierarchy_SalesArea)
            self.hierSARow.setDefaults()
            self.hierSARow.cif.WB_CUSTH_ID = self._hierStructure.wbId
            self._hierStructure.dbContext.add(esWB_Customer_Hierarchy_SalesArea, self.hierSARow)
        }

        // Currently assumes everything is set..
        if (self._bDelete) {
            self.hierSARow.markDeleted()
        } else {
            self.hierSARow.cif.WB_SALESAREA_ID = (self.wbSalesAreaId || 0)
        }
        self._hierStructure.dbContext.SaveBatch(esWB_Customer_Hierarchy_SalesArea, self.hierSARow)

    }


}